import FinalScene from "./scenes/FinalScene";
import MakeScene from "./scenes/MakeScene";
import Title from "./scenes/Title";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [Title, MakeScene, FinalScene],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: Title.KEY,
    // startScene: MakeScene.KEY,
    // startScene: FinalScene.KEY,

    selectedType: 0,

    menuNameIndex: ["backpack", "colors", "patterns", "patches", "keychains"],
    menu: [
        {
            name: "backpack", type: "click", bgColor: "#21b99d",
            id: "BACKPACK", data: { bgPrefix: "BIG_BAG" },
            textKey: "game_screen.bottom_menu.bag_style"
        },

        {
            name: "colors", type: "color", bgColor: "#f89a3c",
            id: "COLOR",
            data: {
                colors: ["blue", "purple", "red", "white", "green", "yellow", "orange", "black"],
                colorValues: {
                    blue: { outline: '#11937a', light: '#26c6a7', dark: '#22ba9d', gradient: ['#22ba9d', '#c1f9ef'], handle: ['#11937a', '#22ba9d', '#EE1326'] },//'#'
                    purple: { outline: '#871755', light: '#ba327d', dark: '#af2369', gradient: ['#af2369', '#dba0c5'], handle: ['#871755', '#af2369', '#D72A82'] },
                    red: { outline: '#930f28', light: '#f20c39', dark: '#dd1f3b', gradient: ['#ff1f3b', '#ffbdb9'], handle: ['#930f28', '#dd1f3b', '#FF2245'] },
                    white: { outline: '#c9b39b', light: '#eee0ce', dark: '#e0d5c7', gradient: ['#d1beaa', '#ffffff'], handle: ['#c9b39b', '#e0d5c7', '#e0d5c7'] },
                    green: { outline: '#007f33', light: '#09c655', dark: '#04b24b', gradient: ['#0fa038', '#adffbc'], handle: ['#007f33', '#04b24b', '#FBF0E2'] },
                    yellow: { outline: '#b04a00', light: '#f7a616', dark: '#f98c15', gradient: ['#f9a115', '#f8dd91'], handle: ['#b04a00', '#f98c15', '#FFAE1B'] },
                    orange: { outline: '#c43402', light: '#ff7900', dark: '#ff5914', gradient: ['#ff5914', '#ffae9c'], handle: ['#c43402', '#ff5914', '#FF870A'] },
                    black: { outline: '#231f20', light: '#474546', dark: '#3a3738', gradient: ['#3a3738', '#817e7f'], handle: ['#231f20', '#3a3738', '#454243'] }
                },
                fillTypes: ["fill", "gradient", "arrows", "dots", "stripes"]
            },
            textKey: "game_screen.bottom_menu.colors"
        },

        {
            name: "patterns", type: "click", bgColor: "#f45137",
            data: [
                { textureName: "pixels", tileType: "square", xoff: 0, yOff: 0 },
                { textureName: "space", tileType: "square", xoff: 0, yOff: 0 },
                { textureName: "flower", tileType: "hex", xoff: 80, yOff: 135 },
                { textureName: "bread", tileType: "hex", xoff: 73, yOff: 125 },
                { textureName: "fuzzbugs", tileType: "square", xoff: 0, yOff: 0 },
                { textureName: "giftwrap", tileType: "hex", xoff: 48, yOff: 80 },
                { textureName: "bugs", tileType: "hex", xoff: 84, yOff: 144 },
                { textureName: "skulls", tileType: "hex", xoff: 73, yOff: 121 },
                { textureName: "ghosts", tileType: "square", xoff: 0, yOff: 0 },
                { textureName: "leaves", tileType: "hex", xoff: 73, yOff: 121 },
                { textureName: "turkey", tileType: "hex", xoff: 73, yOff: 121 }
            ],
            id: "PATTERNS_button",
            textKey: "game_screen.bottom_menu.patterns"
        },

        {
            name: "patches", type: "dragdrop", bgColor: "#21b99d",
            id: "PATCH",
            textKey: "game_screen.bottom_menu.patches"
        },

        {
            name: "keychains", type: "dragdrop", bgColor: "#f89a3c",
            id: "KEYCHAIN",
            textKey: "game_screen.bottom_menu.keychains"
        }
    ],
    backpackParts: [
        // 1
        {
            stylePrefix: "backpackstyle1/",
            mainFill: { textureName: 'FILL_full_backpack', x: 0, y: 0 },
            pocketFills: [
                { textureName: 'FILL_pocket_left', pos: { x: 0, y: 374 } },
                { textureName: 'FILL_pocket_right', pos: { x: 428, y: 374 } },
                { textureName: 'FILL_pocket_front', pos: { x: 87, y: 308 } }
            ],
            outlines: [
                { textureName: 'OUTLINE_main', pos: { x: 27, y: 68 } },
                { textureName: 'OUTLINE_pocket_left', pos: { x: 0, y: 372 } },
                { textureName: 'OUTLINE_pocket_right', pos: { x: 427, y: 372 } },
                { textureName: 'OUTLINE_pocket_front', pos: { x: 85, y: 306 } }
            ],
            handles: {
                fills: [
                    { textureName: 'FILL-handle-top', pos: { x: 177, y: 1 }, fillColorIndex: 1 },
                    { textureName: 'FILL-handle-bottom', pos: { x: 177, y: 28 }, fillColorIndex: 1 }
                ],
                outlines: [
                    { textureName: 'OUTLINE-handle-top', pos: { x: 177, y: 2 } },
                    { textureName: 'OUTLINE-handle-bottom', pos: { x: 175, y: 28 } }
                ]
            },
            accessories: [{ textureName: 'zipper', pos: { x: 300, y: 382 } }]
        },
        // 2
        {
            stylePrefix: "backpackstyle2/",
            mainFill: { textureName: 'FILL_full_backpack', x: 0, y: 0 },
            pocketFills: [
                { textureName: 'FILL_backpack_top_flap', pos: { x: 44, y: 51 } },
                { textureName: 'FILL_pocket_top_flap', pos: { x: 86, y: 354 } },
                { textureName: 'FILL_pocket_bottom', pos: { x: 85, y: 415 } }
            ],
            outlines: [
                { textureName: 'OUTLINE_main', pos: { x: 0, y: 166 } },
                { textureName: 'OUTLINE_backpack_top_flap', pos: { x: 44, y: 51 } },
                { textureName: 'OUTLINE_pocket_top_flap', pos: { x: 86, y: 352 } },
                { textureName: 'OUTLINE_pocket_bottom', pos: { x: 84, y: 414 } }
            ],
            handles: {
                fills: [],
                outlines: [],
                singleTexture: "handle"
            },
            accessories: [{ textureName: 'buckle', pos: { x: 215, y: 49 } }, { textureName: 'buckle2', pos: { x: 215, y: 352 } }]
        },
        // 3
        {
            stylePrefix: "backpackstyle3/",
            mainFill: { textureName: 'FILL_full_backpack', x: 0, y: 0 },
            pocketFills: [
                //  {textureName:'FILL_backpack_top_flap',pos:{x:63,y:53}},
                { textureName: 'FILL_patch_right', pos: { x: 473, y: 377 } },
                { textureName: 'FILL_patch_left', pos: { x: 78, y: 379 } },
                { textureName: 'FILL_strap_vertical', pos: { x: 559, y: 113 } },
                { textureName: 'FILL-handle-left-top', pos: { x: 0, y: 122 } }


            ],
            outlines: [
                { textureName: 'OUTLINE_main', pos: { x: 74, y: 223 } },
                { textureName: 'OUTLINE_patch_left', pos: { x: 75, y: 378 } },
                { textureName: 'OUTLINE_patch_right', pos: { x: 472, y: 376 } },
                { textureName: 'OUTLINE_strap_vertical', pos: { x: 559, y: 113 } },
                { textureName: 'OUTLINE-handle-left-top', pos: { x: 0, y: 121 } },

                { textureName: 'OUTLINE_backpack_top_flap', pos: { x: 63, y: 51 } }
            ],
            handles: {
                fills: [
                    { textureName: "FILL-handle-top", pos: { x: 266, y: 0 }, fillColorIndex: 1 }
                ],
                outlines: [
                    { textureName: "OUTLINE-handle-top", pos: { x: 266, y: 0 } },
                    { textureName: "FILL-handle-right-bottom", pos: { x: 540, y: 398 } },
                    { textureName: "FILL-handle-left-bottom", pos: { x: 25, y: 397 } }
                ]
            },
            accessories: [
                { textureName: "metal-left", pos: { x: 47, y: 112 } },
                { textureName: "metal-right", pos: { x: 558, y: 107 } }
            ]
        },
        // 4
        {
            stylePrefix: "backpackstyle4/",
            mainFill: { textureName: 'FILL_full_backpack', x: 0, y: 0 },
            pocketFills: [

                { textureName: 'FILL_pocket_left', pos: { x: 35, y: 393 } },
                { textureName: 'FILL_pocket_right', pos: { x: 400, y: 388 } }
            ],
            outlines: [
                { textureName: 'FILL_strap_top_left', pos: { x: 65, y: 14 } },
                { textureName: 'FILL_strap_top_right', pos: { x: 384, y: 11 } },
                { textureName: 'FILL_strap_bottom_left', pos: { x: 0, y: 455 } },
                { textureName: 'FILL_strap_bottom_right', pos: { x: 458, y: 448 } },
                { textureName: 'OUTLINE_main', pos: { x: 33, y: 0 } },
                { textureName: 'OUTLINE_pocket_right', pos: { x: 397, y: 387 } },
                { textureName: 'OUTLINE_pocket_left', pos: { x: 33, y: 390 } }
            ],
            handles: {},
            accessories: [
                { textureName: "ring_left", pos: { x: 51, y: 445 } },
                { textureName: "ring_right", pos: { x: 447, y: 441 } }
            ]
        }
    ]
}
